import { render, staticRenderFns } from "./SummaryPerNationalityBarGraph.vue?vue&type=template&id=6e892e51&scoped=true&"
import script from "./SummaryPerNationalityBarGraph.vue?vue&type=script&lang=js&"
export * from "./SummaryPerNationalityBarGraph.vue?vue&type=script&lang=js&"
import style0 from "./SummaryPerNationalityBarGraph.vue?vue&type=style&index=0&id=6e892e51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e892e51",
  null
  
)

export default component.exports